import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=c355486e&scoped=true&"
import script from "./notificationModal.ts?vue&type=script&lang=ts&"
export * from "./notificationModal.ts?vue&type=script&lang=ts&"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=c355486e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c355486e",
  null
  
)

export default component.exports